import { render, staticRenderFns } from "./Cadastro.vue?vue&type=template&id=84e86c88&scoped=true&lang=pug"
import script from "./Cadastro.vue?vue&type=script&lang=js"
export * from "./Cadastro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84e86c88",
  null
  
)

export default component.exports